<div class="settings-modal-dialog__wrapper">
  <div class="settings-modal-dialog__top">
    <div mat-dialog-title>
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <i class="fal fa-file-pdf i-16 mr-4"></i>
          <span>Export to PDF</span>
        </div>
        <div>
          <button *ngIf="!exporting" trgButton class="dialog-close-btn" (click)="cancel()">
            <i class="fal fa-times i-12 p-relative ot-1"></i>
          </button>
        </div>
      </div>
    </div>
    <div mat-dialog-content class="fs-14 d-flex flex-dir-column">
      <div class="c-blue bold border-b-dotted-1 brc-grey-1 pb-4 mb-12">
        <span>Export: <strong class="c-black">{{dashboard.name}}</strong></span>
      </div>
      <div class="mb-20" [hidden]="failed || success">
        <span *ngIf="!exporting">Specify Paper Size for the exported document</span>
        <span *ngIf="exporting">Please wait while the document is generated...</span>
      </div>
      <div class="settings-section" [class.mb-20]="failed && !exporting" [hidden]="exporting || success">
        <div class="settings-section__group">
          <label class="justify-content-right">Paper Size:</label>
          <div class="settings-section__input max-w-200">
            <mat-select class="trg-outline" panelClass="trg-outline-dropdown min-w-200 max-w-200" [(ngModel)]="paperSize">
              <mat-option *ngFor="let ps of paperSizes" [value]="ps.id">{{ps.title}}</mat-option>
            </mat-select>
          </div>
        </div>
        <div class="settings-section__group" *ngIf="layoutOptions">
          <label class="text-right settings-section-checkbox-offset justify-content-right">Include Header:</label>
          <div class="settings-section__input">
            <trg-checkbox appearance="square" [(value)]="includeHeader"></trg-checkbox>
          </div>
        </div>
        <div class="settings-section__group" *ngIf="layoutOptions">
          <label class="text-right settings-section-checkbox-offset justify-content-right">Include Footer:</label>
          <div class="settings-section__input">
            <trg-checkbox appearance="square" [(value)]="includeFooter"></trg-checkbox>
          </div>
        </div>
      </div>
      <div class="c-grey-5" [hidden]="!failed && !success">
        <div *ngIf="failed" class="d-flex align-items-center c-red">
          <i class="fal fa-exclamation-circle i-14 mr-10"></i>
          <span>Failed to generate the requested document.</span>
        </div>
        <div *ngIf="success" class="d-flex align-items-center">
          <i class="fal fa-file-download i-14 mr-10"></i>
          <span>
            The document has been generated.<br />
            If the download does not start automatically, <a *ngIf="downloadUrl" [href]="downloadUrl" target="_blank" [download]="fileName" class="c-blue">click here</a>.
          </span>
        </div>
      </div>
      <div [hidden]="!exporting" style="flex: 1 0 0;">
        <app-spinner></app-spinner>
      </div>
    </div>
  </div>
  <div mat-dialog-actions align="end" class="settings-modal-dialog__bottom">
    <button *ngIf="!success" trgButton color="outline" class="min-w-70" (click)="cancel()">Cancel</button>
    <button trgButton color="primary" class="min-w-80" (click)="next()" [disabled]="exporting || !valid">
      <span *ngIf="!failed && !success">Export</span>
      <span *ngIf="failed">Retry</span>
      <span *ngIf="success">Close</span>
    </button>
  </div>
</div>
